/**
 * The one person the welcome page names: the founder who tells the story
 * under "Who we are".
 *
 * A name is no interface string, so it lives here rather than in `i18n/`.
 *
 * The page names nobody else. It used to list the properties Optivo prices as
 * references, and a partner beside them; the owners took both off on
 * 8 Oct 2026, a competitor reading the page too, and the page now states how
 * many rooms Optivo prices instead (`PricedRoomsSection.tsx`). A customer or
 * a partner is not named here again without their say-so and the owners'.
 */

export interface WelcomeFounder {
    name: string;
    portrait: { src: string; width: number; height: number };
}

/** His own portrait, handed over for this page; the file is in `public/welcome/`. */
export const WELCOME_FOUNDER: WelcomeFounder = {
    name: "Ondřej Kulič",
    portrait: { src: "/welcome/ondrej-kulic.jpg", width: 600, height: 800 },
};
